import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Context from './Context';

const ConfigurationProvider = ({ children }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const splideOptions = useMemo(
    () => ({
      perPage: 1,
      pagination: false,
      arrows: false,
      gap: '100%',
      width: '264px',
      start: currentSlide,
    }),
    [currentSlide],
  );

  const contextValue = useMemo(
    () => ({
      currentSlide,
      setCurrentSlide,
      splideOptions,
    }),
    [currentSlide, splideOptions],
  );

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};

ConfigurationProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default ConfigurationProvider;
